<template>
    <BaseTooltip>
        <template v-slot:content>
            <div 
                class="ellipsis" 
                :alvqa="alvqa + '-header-stats'"
                style="line-height:1.2 !important"
            >
                    {{ generateStatsText }}
            </div>
        </template>
        <template v-slot:text>
            {{ $t("lang_GENERIC_HEADER_STATS_MOUSEOVER") }} ({{ $n(listedRecords) }})
        </template>
    </BaseTooltip>
</template>

<script>
import BaseTooltip from './BaseTooltip'

export default {
    name: "BaseHeaderStats",
    components: {
        BaseTooltip
    },
    props: {
        context: String,
        typeStats: { // pass with capital letters
            type: String,
            default: 'LIST'
        },
        alvqa: {
            type: String,
            default: ''
        },
        useContextForTotal: {
            type: String,
            default: ''
        },
        specificSelected: {
            type: Number,
            default: null
        }
    },
    computed: {
        // selected() { return this.$store.getters['getSelected'+this.context].length },
        // listedRecords() { return this.$store.getters['getTotal'+this.context+'Listed'] },
        // totalRecords() { return this.$store.getters['getTotal'+this.context+'Records'] },
        selected() { return this.$store.getters['getSelected'+this.context].length },
        listedRecords() { 
            if(this.useContextForTotal !== '') return this.$store.getters['getTotalListed'+this.useContextForTotal]
            else return this.$store.getters.getTotalListed 
        },
        totalRecords() { 
            if(this.useContextForTotal !== '') return this.$store.getters['getTotalRecords'+this.useContextForTotal]
            else return this.$store.getters.getTotalRecords 
        },
        getLangConst() { return this.$t('lang_HEADER_STATS_' + this.typeStats + '_TEXT') },
        generateStatsText() {
            let str = this.getLangConst
            str = str.replace('<selected>', this.specificSelected !== null ? this.$n(this.specificSelected, 'numberInteger'): this.$n(this.selected, 'numberInteger'))
            str = str.replace('<results>', this.$n(this.listedRecords, 'numberInteger'))
            str = str.replace('<total>', this.$n(this.totalRecords, 'numberInteger'))
            return str 
        }
    },
}
</script>